import React, { useEffect, useRef } from 'react';
import { Flex, ChatMessage, Text, Box } from 'pcln-design-system';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
import VerificationCode from '../VerificationCode/VerificationCode';
import { useOtpContext } from '../../context/OtpContext';
import OtpForm from '../OtpForm/OtpForm';
import MessageFooter from '../MessageFooter/MessageFooter';
import FindMyTripsErrors from './ErrorComponent';
import { otpDeliveryMechanisms } from '../../constants';
const FindMyTrips = () => {
  const messageEndRef = useRef(null);
  const {
    otpDeliveryType,
    showOtpVerificationForm
  } = useOtpContext();
  const deliveryDestination = otpDeliveryType === otpDeliveryMechanisms.SMS ? 'phone number' : '';
  useEffect(() => {
    var _a;
    (_a = messageEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
      behavior: 'smooth'
    });
  }, [showOtpVerificationForm]);
  return React.createElement(React.Fragment, null, React.createElement(Flex, {
    mb: 4
  }, React.createElement(ChatMessage, {
    ml: '',
    mb: '20px',
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: React.createElement(React.Fragment, null, React.createElement(Text, {
      mb: 3
    }, "To assist you with your trip, please provide the phone number and email address associated with your booking. This helps us quickly find your reservation and provide the best support."), showOtpVerificationForm ? React.createElement(Text, {
      fontWeight: 'bold'
    }, "We've sent a verification code to the ", deliveryDestination, " provided.") : React.createElement(OtpForm, null)),
    footer: React.createElement(MessageFooter, null)
  })), showOtpVerificationForm ? React.createElement(Flex, {
    mb: 4
  }, React.createElement(ChatMessage, {
    ml: '',
    mb: '20px',
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: React.createElement(React.Fragment, null, React.createElement(Text, {
      mb: 3
    }, "Please enter the code sent to the phone number provided. "), React.createElement(VerificationCode, null)),
    footer: React.createElement(MessageFooter, null)
  })) : null, React.createElement(FindMyTripsErrors, null), React.createElement(Box, {
    ref: messageEndRef
  }));
};
export default FindMyTrips;